import { useEffect, useState, useCallback } from "react";
import { toast } from "react-toastify";
import useApiClient, { apiRoutes } from "../../../hooks/apiClient";

const useBuscaSafePayload = () => {
  const {
    request: requestSafePayload,
    data: dataSafePayload,
    errors: errorSafePayload,
    isLoading: isLoadingSafePayload,
  } = useApiClient();

  const [safePayloadAgrupador, setSafePayloadAgrupador] = useState();

  const buscaSafePayload = useCallback(
    (data) => {
      requestSafePayload(apiRoutes.usuarios.arquivo.selecionar, data);
    },
    [requestSafePayload],
  );

  useEffect(() => {
    if (isLoadingSafePayload) return;

    if (dataSafePayload) {
      setSafePayloadAgrupador(dataSafePayload.result);
    }

    if (errorSafePayload) {
      toast.error(errorSafePayload.message);
    }
  }, [dataSafePayload, errorSafePayload, isLoadingSafePayload]);

  return { isLoadingSafePayload, buscaSafePayload, safePayloadAgrupador, errorSafePayload };
};

export default useBuscaSafePayload;
